export default {
  documentType: '',
  employees: [],
  employeeIds: [],
  templateId: ''
};
